module.exports = __webpack_public_path__ + "img/icon-slack-dark.4d66b3d4.svg";